export default __webpack_public_path__ + "static/media/down_arrow_icon.4bdedee1.png";